import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { useBreadcrumbs } from "@/hooks/useBreadcrumbs";
import { useTranslation } from "react-i18next";
import { ROUTES } from "@/constants/routeConstants";
import { LanguageSelector } from "@/components/LanguageSelector";
import { ThemeToggle } from "@/components/theme/ThemeToggle";

export const SettingsPage = () => {
  const { t } = useTranslation();

  useBreadcrumbs([{ name: t("siteSettings.title"), path: ROUTES.SETTINGS }]);

  return (
    <Card className="max-w-[550px]">
      <CardHeader>
        <CardTitle className="text-2xl">{t("siteSettings.title")}</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="flex flex-row gap-4 items-center mt-4">
          <div className="flex w-[80px]">{t("siteSettings.theme")}</div>
          <ThemeToggle />
        </div>
        <div className="flex flex-row gap-4 items-center mt-4">
          <div className="flex w-[80px]">{t("siteSettings.language")}</div>
          <LanguageSelector />
        </div>
      </CardContent>
    </Card>
  );
};
